export enum RejectTaskActionsShow {
  ALWAYS = 'always',
  NEVER = 'never',
}

export type RejectTaskActionsData = {
  show: RejectTaskActionsShow;
  fields: {
    predefined_observations: {
      show: boolean;
      show_in_bulk: boolean;
      options: Array<{
        id: string;
        name: string;
        condition: string;
      }>;
    };
    resolutions: {
      show: boolean;
      show_in_bulk: boolean;
      options: Array<{
        id: string;
        name: string;
        isFinal: boolean;
      }>;
    };
    observations_for_client: {
      show: boolean;
      show_in_bulk: boolean;
      mandatory: boolean;
    };
    attachments: {
      show: boolean;
      show_in_bulk: boolean;
    };
  };
};

export class RejectTaskActions {
  constructor(public readonly value: RejectTaskActionsData) {}

  shouldShowModal() {
    if (this.value.show === RejectTaskActionsShow.ALWAYS) {
      return true;
    }

    if (this.value.show === RejectTaskActionsShow.NEVER) {
      return false;
    }

    // otherwise
    return false;
  }

  shouldShowPredefinedObservations(bulkMode: boolean = false): boolean {
    if (bulkMode) {
      return this.value.fields.predefined_observations.show_in_bulk;
    }

    return this.value.fields.predefined_observations.show;
  }

  shouldShowResolutions(bulkMode: boolean = false): boolean {
    if (!this.value.fields.resolutions) {
      return false;
    }

    if (bulkMode) {
      return this.value.fields.resolutions.show_in_bulk;
    }

    return this.value.fields.resolutions.show;
  }

  shouldShowObservations(bulkMode: boolean = false): boolean {
    if (bulkMode) {
      return this.value.fields.observations_for_client.show_in_bulk;
    }

    return this.value.fields.observations_for_client.show;
  }

  isObservationsMandatory(): boolean {
    return this.value.fields.observations_for_client.mandatory;
  }

  shouldShowAttachments(bulkMode: boolean = false): boolean {
    if (bulkMode) {
      return this.value.fields.attachments.show_in_bulk;
    }

    return this.value.fields.attachments.show;
  }

  optionsForDate(): Array<{ id: string; label: string }> {
    const allOptions = this.value.fields.predefined_observations.options;

    return allOptions.map((o) => ({
      id: o.id,
      label: o.name,
    }));
  }

  optionsForResolutions(): Array<{ id: string; label: string }> {
    const allOptions = this.value.fields.resolutions.options;

    return allOptions.map((o) => ({
      id: o.id,
      label: o.name,
    }));
  }

  isResolutionFinal(resolutionId: string): boolean {
    return this.value.fields.resolutions.options.find((r) => r.id === resolutionId)?.isFinal ?? false;
  }
}
